import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { clearAuctionBet, closeAuction, EBetPositionStatus, revertAuctionBet } from '../../../../redux/reducers';
import {
  selectCurrentBet,
  selectIsAuctionEnabled,
  selectIsAuctionOpen,
  selectIsAutobrokerEnabled,
  selectPrevBet,
} from '../../../../selectors/auction';
import { selectBetPositionStatus } from '../../../../selectors/betPosition';
import { selectActiveServiceId } from '../../../../selectors/publishTerms';
import { AuctionMobile } from './AuctionMobile';

export const AuctionMobileContainer = () => {
  const isMobile = useIsMobileDevice();

  const isAuctionOpen = useSelector(selectIsAuctionOpen);
  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);
  const isAutobrokerEnabled = useSelector(selectIsAutobrokerEnabled);
  const selectedServiceId = useSelector(selectActiveServiceId);
  const currentBet = useSelector(selectCurrentBet);
  const prevBet = useSelector(selectPrevBet);
  const status = useSelector(selectBetPositionStatus);

  const dispatch = useDispatch<TDispatch>();

  const isFail = status === EBetPositionStatus.fail;
  const isAcceptDisabled = currentBet === prevBet || isFail;

  const handleClose = React.useCallback(() => {
    dispatch(closeAuction());

    if (currentBet !== prevBet) {
      dispatch(revertAuctionBet());
    }
  }, [dispatch, currentBet, prevBet]);

  const handleClear = React.useCallback(() => {
    dispatch(closeAuction());

    if (currentBet !== 0) {
      dispatch(clearAuctionBet());
    }
  }, [dispatch, currentBet]);

  const handleAccept = React.useCallback(() => {
    dispatch(closeAuction());
  }, [dispatch]);

  if (!isMobile || !selectedServiceId || !isAuctionEnabled) {
    return null;
  }

  return (
    <AuctionMobile
      isOpen={isAuctionOpen}
      isAcceptDisabled={isAcceptDisabled}
      isAutobrokerEnabled={isAutobrokerEnabled}
      onClose={handleClose}
      onClear={handleClear}
      onAccept={handleAccept}
    />
  );
};
